// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MVpb","col":"styles_col__3qsDx","actions":"styles_actions__2coFn","conflict":"styles_conflict__3h9wv"};